import { LoginComponent } from '../../../login/login.component';

import { HardcodedAutheticationService } from '../../../service/hardcoded-authetication.service';
import { Localidad } from '../../../models/localidad.model';
import { EventoDataService } from '../../../service/data/evento-data.service';
import { Evento } from '../../evento.model';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MensajeComponent } from 'src/app/mensaje/mensaje.component';
import { MensajeLinkComponent } from 'src/app/mensaje-link/mensaje-link.component';
import { ClientePagos } from 'src/app/models/cliente-pagos.model';
import { ClientesPagoDataService } from 'src/app/service/data/clientes-pago-data.service';
import { OrdenDataService } from 'src/app/service/data/orden-data.service';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe, registerLocaleData } from '@angular/common';
import { MetaPixelService } from '../../meta-pixel/meta-pixel.service';
import localeES from '@angular/common/locales/es';
import { GoogleAnalyticService } from '../../google-analytic/google-analytic.service';
import { error } from 'console';

@Component({
  selector: 'app-compra',
  templateUrl: './compra.component.html',
  styleUrls: ['./compra.component.css'],
  standalone: false
})
export class CompraComponent implements OnInit {
  miId;
  valorTotal: number
  evento: Evento;
  cantidadTotal: number;
  cantidades: number[]
  cargando: boolean
  idLocalidad
  codigoVenta
  localidades: Localidad[];
  urlPrimeraImagenTipo1: string
  usuario: string
  cliente: ClientePagos

  constructor(private route: ActivatedRoute,
    public dialog: MatDialog,
    private service: EventoDataService,
    private autenticador: HardcodedAutheticationService,
    private router: Router,
    private clienteDataService: ClientesPagoDataService,
    private metaPixelService: MetaPixelService,
    private googleAnalyticService: GoogleAnalyticService,
    private ordenService: OrdenDataService) { }

  ngOnInit(): void {
    this.cantidades = []
    this.valorTotal = 0
    this.cantidadTotal = 0
    this.evento = new Evento();
    this.cargando = true;

    this.route.paramMap.subscribe(params => {
      this.miId = params.get('id');
      this.codigoVenta = params.get('codigoVenta')
      this.service.getEventoIdPerfilNoSoldOut(this.miId).subscribe(response => {
        if (response) {
          this.handleGetSuccesfull(response);
          this.metaPixelService.inicializarPixelSiEsNecesario(this.evento.metaPixel)
          this.darURL(1)
          this.cargando = false;
        } else {
          this.cargando = false;
          this.mensaje("No tienes ningun proceso de compra")
        }

      }, error => {
        this.cargando = false;
        this.mensajeEventoNoDisponible("El evento no se encuentra disponible para la compra, regresa a la pagina principal y revisa los eventos disponibles")
      });
    })

    this.autenticar()
  }

  handleGetSuccesfull(response) {

    this.evento = response.evento;
    this.localidades = response.localidades
    for (let i = 0; i < this.localidades.length; i++) {
      this.cantidades.push(0);
    }
  }
  agregarBoletasACompra(i) {

    this.valorTotal = 0
    this.cantidadTotal = 0
    var localidad = this.localidades[i];

    //HARDCODE GREEN VELVET y DOOM ZONA CERO
    //ELIMINAR CUANDO PASE EL EVENTO
    if (this.evento.id == 1986) {
      this.valorTotal += this.cantidades[i] * (localidad.precio + localidad.servicio + localidad.servicio_iva)
    }


    else {
      this.valorTotal += this.cantidades[i] * (localidad.precio + localidad.servicio + localidad.servicio_iva) * localidad.cantidadPersonasPorTicket
    }
    this.cantidadTotal = this.cantidadTotal + this.cantidades[i]

  }


  validar(i) {
    let encontro: boolean = false
    let deshabilitar: boolean = true
    let k;

    for (let j = 0; j < this.cantidades.length; j++) {
      if (this.cantidades[j] > 0) {
        encontro = true;
        k = j;
      }
    }
    if (encontro && k == i) {
      deshabilitar = false
    }
    else if (!encontro) {
      deshabilitar = false
    }
    return deshabilitar;

  }

  AbrirCarrito(): void {

    if (this.cantidadTotal == 0) {
      this.mensaje("Selecciona lo que deseas comprar")
      return
    }

    if (this.autenticador.getUsuario()) {

      if (!this.cliente) {
        this.autenticar().then(() => {
          this.crearOrden()
        })
      }
      else {
        this.crearOrden()
      }
    }
    else {

      this.mensaje("Debes estar registrado en All Tickets para poder realizar tu compra, en caso de no estarlo por favor crea una cuenta nueva", true)
    }

  }

  crearOrden(): void {
    const numerosNoCero = this.cantidades.filter(num => num !== 0);
    if (numerosNoCero.length == 1) {
      const posicion = this.cantidades.indexOf(numerosNoCero[0]);
      let localidad: Localidad = this.localidades[posicion]
      this.idLocalidad = localidad.id
      let tipo: number = (localidad.tipo == 1 || localidad.tipo == 3) ? 4 : 1
      this.cargando = true

      if (!this.codigoVenta) {
        this.ordenService.crearOrdenClienteCompra(this.cantidadTotal, this.idLocalidad, tipo, this.evento.id, this.cliente).subscribe({
          next: response => {
            if (response.ordenId) {
              // agrega aqui el track event 
              this.googleAnalyticService.trackAddToCart(this.evento.googleAnalytic)
              // Rastrear el evento AddToCart si el pixel está inicializado
              if (window['fbqInitialized']) {
                this.metaPixelService.trackAddToCart();
              } else {
                console.warn('El Meta Pixel no está inicializado. No se puede rastrear InitialCheckout.');
              }
              this.router.navigate([`/eventos/carrito/${response.ordenId}`])
            }
            else if (response.mensaje) {
              this.cargando = false
              this.mensaje(response.mensaje)
            }
          }, error: error => {
            this.cargando = false
            this.mensaje("Sucedio un error al generar la orden, por favor intenta nuevamente")
          }
        })
      }
      else {
        this.ordenService.crearOrdenClienteCompraPromotor(this.cantidadTotal, this.idLocalidad, tipo, this.evento.id, this.cliente, this.codigoVenta).subscribe({
          next: response => {
            if (response.ordenId) {
              this.router.navigate([`/eventos/carrito/${response.ordenId}`])
            }
            else if (response.mensaje) {
              this.cargando = false
              this.mensaje(response.mensaje)
            }

          }, error: error => {
            this.mensaje("Sucedio un error al generar la orden, por favor intenta nuevamente")
            this.cargando = false
          }
        })
      }

    } else {
      this.mensaje("No se permite la compra de mas de una localidad por compra")
    }
  }


  darFecha(evento: Evento): string {

    if (evento.fecha == null) {
      return 'Por confirmar'
    }

    registerLocaleData(localeES, 'es');
    let dataPipe: DatePipe = new DatePipe('es');
    let Word = dataPipe.transform(evento.fecha, 'EEE dd');
    Word = Word[0].toUpperCase() + Word.substr(1).toLowerCase();

    let Word2 = dataPipe.transform(evento.fecha, 'MMM');
    Word2 = Word2[0].toUpperCase() + Word2.substr(1).toLowerCase();


    let fecha = Word + " de " + Word2 + " de " + dataPipe.transform(evento.fecha, 'yyyy');

    return fecha
  }

  openDialogMensaje(mensaje, eventoId): void {
    const dialogRef = this.dialog.open(MensajeLinkComponent, {

      width: '600px',
      height: '250px',
      data: {
        mensaje: mensaje,
        id: eventoId
      }

    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  mensaje(mensaje, login?): void {
    const dialogRef = this.dialog.open(MensajeComponent, {

      width: '600px',
      maxHeight: '250px',

      data: {
        mensaje: mensaje,
      }

    });

    dialogRef.afterClosed().subscribe(result => {
      if (login) {

        this.openDialog()
      }
    });
  }


  mensajeEventoNoDisponible(mensajeT: string): void {
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: '600px',
      maxHeight: '250px',
      data: {
        mensaje: mensajeT,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['/']);
    });
  }



  openDialog(): void {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '600px',
    });


    dialogRef.afterClosed().subscribe(result => {

      this.autenticar()
    });
  }

  darURL(tipo) {

    const primeraImagenTipo1 = this.evento.imagenes.find(imagen => imagen.tipo === tipo);
    this.urlPrimeraImagenTipo1 = "";
    if (primeraImagenTipo1) {
      this.urlPrimeraImagenTipo1 = primeraImagenTipo1.url;
    }
    return this.urlPrimeraImagenTipo1
  }

  async autenticar() {
    this.usuario = this.autenticador.getUsuario();
    if (this.usuario) {
      return new Promise((resolve) => {
        this.clienteDataService.getClientePago(this.usuario).subscribe({
          next: response => {
            this.cliente = response.cliente;
            resolve(true);
          }
        });
      });
    }
  }



}
